export const apiPermissions = {
  "restaurant/orders/list": { Method: "READ", Page: "live_orders" },
  "restaurant/status/{orderId}/update": {
    Method: "MODIFY",
    Page: "live_orders,order_details",
  },
  "restaurant/payment/status": {
    Method: "MODIFY",
    Page: "live_orders,order_details",
  },
  "order/{orderId}/data": { Method: "READ", Page: "order_details" },
  "restaurant/dashboard/{rest_id}/data": { Method: "READ", Page: "dashboard" },
  "imagespool/list": { Method: "READ", Page: "theme,image_library" },
  "image/update/{type}": { Method: "MODIFY", Page: "image_library" },
  "restaurant/setting": { Method: "READ", Page: "settings" },
  "setting/generalSettings": { Method: "MODIFY", Page: "settings" },
  "setting/serviceOptions": { Method: "MODIFY", Page: "settings" },
  "setting/paymentSettings": { Method: "MODIFY", Page: "settings" },
  "restaurant/{id}/open": { Method: "MODIFY", Page: "settings" },
  "restaurant/{id}/close": { Method: "MODIFY", Page: "settings" },
  "restaurant/themedata": { Method: "READ", Page: "theme" },
  "image/{type}": { Method: "MODIFY", Page: "theme" },
  "restaurant/{id}/theme": { Method: "MODIFY", Page: "theme" },
  "restaurant/customers/data": { Method: "READ", Page: "customers" },
  "order/invoices/list": { Method: "READ", Page: "invoices,order_details" },
  "menu/list": { Method: "READ", Page: "menu" },
  "menu/{id}/category/list": { Method: "READ", Page: "add_item,menu" },
  "menu/{id}/delete": { Method: "MODIFY", Page: "menu" },
  "menu/category/{category_id}/item/{item_id}": {
    Method: "MODIFY",
    Page: "menu",
  },
  "menu/{id}/addon/list": { Method: "READ", Page: "menu,add_item" },
  "menu/test-id/item/list": { Method: "READ", Page: "menu" },
  "position/{id}/items": { Method: "MODIFY", Page: "menu" },
  "position/category": { Method: "MODIFY", Page: "menu" },
  "menu/{id}/update": { Method: "MODIFY", Page: "menu" },
  "menu/add/category": { Method: "MODIFY", Page: "menu,add_item" },
  "menu/add/addongroup": { Method: "MODIFY", Page: "add_item,menu" },
  "menu/test-id/category/list": { Method: "READ", Page: "menu" },
  "menu/{id}/addongroup/list": { Method: "READ", Page: "add_item,menu" },
  "menu/{id}/get": { Method: "READ", Page: "add_item" },
  "menu/add/item": { Method: "MODIFY", Page: "add_item" },
  "restaurant/orders/export/links": {
    Method: "READ",
    Page: "Bluk_Export_orders",
  },
  "restaurant/orders/export": { Method: "READ", Page: "Bluk_Export_orders" },
  "menu/get": { Method: "READ", Page: "add_item" },
  "menu/{id}/item/list": { Method: "READ", Page: "menu" },
  "restaurant/menu/import": { Method: "MODIFY", Page: "menu" },
  "restaurant/menu/export": { Method: "READ", Page: "menu" },
  "restaurant/coupons": { Method: "READ", Page: "coupons" },
  "restaurant/coupons/analytics": {
    Method: "READ",
    Page: "coupons_analytics",
  },
  "restaurant/coupons/dashboard": { Method: "READ", Page: "coupons" },
  "restaurant/coupon/{id}/update": { Method: "MODIFY", Page: "coupons" },
  "restaurant/coupon/create": { Method: "MODIFY", Page: "coupons" },
  "restaurant/coupon/{id}/status": { Method: "MODIFY", Page: "coupons" },
  "restaurant/version": { Method: "READ", Page: "version_control" },
  "setting/version": { Method: "MODIFY", Page: "version_control" },
  "restaurant/menu/{addongroupId}/item": {
    Method: "MODIFY",
    Page: "add_item,menu",
  },
  "coupons/updatedb": { Method: "MODIFY", Page: "coupons" },
  "restaurant/menuitem/{item_id}/instruction/update": {
    Method: "MODIFY",
    Page: "menu",
  },
  "restaurant/menuitem/{item_id}/stock/update": {
    Method: "MODIFY",
    Page: "menu",
  },
  //pdf
  //restaurant/users/{rest_id}/data
  //restaurant/menuitem/{item_id}/instruction/update
}; //coupons/updatedb

export const Group = {
  "36ead77d-b998-4962-b239-91d948b33eb4": {
    created_at: 1700885679383,
    name: "Manager",
    permissions: {
      add_item: "NO_ACCESS",
      settings: "NO_ACCESS",
      live_orders: "NO_ACCESS",
      invoices: "NO_ACCESS",
      theme: "NO_ACCESS",
      image_library: "NO_ACCESS",
      customers: "NO_ACCESS",
      menu: "NO_ACCESS",
      order_details: "NO_ACCESS",
      dashboard: "NO_ACCESS",
    },
    updated_at: 1701825277071,
  },
};
